import { render } from "./NetworkRtkStatsPage.vue?vue&type=template&id=4606b9b0"
import script from "./NetworkRtkStatsPage.vue?vue&type=script&lang=js"
export * from "./NetworkRtkStatsPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__